import { Button, Container, Nav, Navbar } from "react-bootstrap";
import NavImageButton from "../../atoms/navimagebutton/NavImageButton";
import NavButtonCollection from "../../molecules/navbuttoncollection/NavButtonCollection";
import "./NavbarOrganism.css";
import { Link, useNavigate } from "react-router-dom";
import { msalInstance } from "../../..";
import NavTextButton from "../../atoms/navtextbutton/NavTextButton";


const NavbarOrganism = () => {
  const navigate = useNavigate();

  const handleLinkClick = (path: string) => {
    navigate(path);
  };

  return (
    <Navbar
      expand="md"
      className="navbarorganism shadow"
    >
      <Container fluid className="d-flex align-items-center justify-content-start">
        <Navbar.Brand className="homebutton">
          <Link to="/" onClick={() => handleLinkClick('/')}>
            <NavImageButton />
          </Link>
        </Navbar.Brand>
        <NavButtonCollection />
        <Nav className="ms-auto">
          <div className="text-center">
            <Nav.Item className="header-text text-center fw-bold">
              {msalInstance.getActiveAccount()?.name}
            </Nav.Item>
            <Button
              style={{ textDecoration: "none" }}
              className="logout-button"
              onClick={() => msalInstance.logoutPopup()}
            >
              <NavTextButton title="Logga ut" />
            </Button>
          </div>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavbarOrganism;